import { createContext, useContext } from 'react';

const LanguageUrlsContext = createContext(undefined);

LanguageUrlsContext.displayName = 'LanguageUrlsContext';

export const LanguageUrlsProvider = LanguageUrlsContext.Provider;

export const useLanguageUrls = () => useContext(LanguageUrlsContext);
